// Отметка «подводку к push уже показывали» — общая для браузера (push-init) и
// приложения (native-push-init): человека не спрашиваем дважды.

const PROMPT_SEEN_KEY = "studyhub:push-prompt-seen";

export function readPushPromptSeen(): boolean {
	try {
		return localStorage.getItem(PROMPT_SEEN_KEY) === "1";
	} catch {
		return false;
	}
}

export function markPushPromptSeen(): void {
	try {
		localStorage.setItem(PROMPT_SEEN_KEY, "1");
	} catch {
		// localStorage недоступен (private mode) — pre-prompt покажется ещё раз, не критично.
	}
}
